import React, { useState } from "react";
// import { FiMenu } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { IoBagOutline } from "react-icons/io5";
// import { CiEdit } from "react-icons/ci";
import { GoTasklist } from "react-icons/go";
// import { PiContactlessPaymentThin } from "react-icons/pi";
// import { SiAwssecretsmanager } from "react-icons/si";
// import { IoIosNotificationsOutline } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { TiPointOfInterestOutline } from "react-icons/ti";
import { BsSignIntersectionY } from "react-icons/bs";
import { BiPurchaseTagAlt } from "react-icons/bi";
import { PiSubtitlesThin } from "react-icons/pi";
import { logoutUser } from "../../Services/authService";
import { FaSignOutAlt  } from "react-icons/fa";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { SIGNOUT_USER_SUCCESS } from "../../Redux/constants/AuthConstant";
import { useDispatch } from "react-redux";

const SideBar = ({ toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const dispatch = useDispatch();
  const handleClick = (path) => {
    navigate(path);
    toggleSidebar();
  };

  const Vendor_Array = [
    "/admin/vendor",
    "/admin/posted_jobs",
    "/admin/view",
    "/admin/team-list",
  ];
  const isActive = (item) => {
    if (item.subPaths) {
      return (
        item.subPaths.some((p) => location.pathname === p) ||
        location.pathname === item.path
      );
    }
    return location.pathname === item.path;
  };

  const logoutHandler = () => {
    const userId = localStorage.getItem("adminid");
    const userTypeR = localStorage.getItem("usertype");
    logoutUser(parseInt(userId), userTypeR).then(() => {
      navigate("/admin-login");
      setTimeout(() => {
        localStorage.clear();
        dispatch({
          type: SIGNOUT_USER_SUCCESS,
          payload: {},
          isSigninIn: false,
          msg: "logout successfully",
        });
      }, 400);
    });
  };

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fffefe",
        borderRight: "1px solid #eee6e4",
        overflowY: "auto",
        height: "100%",
        maxWidth: "15rem",
        minWidth: "15rem",

      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          color: "#286A94",
          fontWeight: "500",
        }}
      >
        <div
          style={{
            paddingTop: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          {[
            { label: "Dashboard", icon: <RxDashboard />, path: "/admin" },
            {
              label: "Vendor Management",
              icon: <IoBagOutline />,
              path: "/admin/vendor",
              subPaths: [
                "/admin/posted_jobs",
                "/admin/view",
                "/admin/team-list",
              ],
            },
            {
              label: "Job Management",
              icon: <GoTasklist />,
              path: "/admin/job",
            },
            {
              label: "Candidate Management",
              icon: <BsSignIntersectionY />,
              path: "/admin/candidate",
            },
            {
              label: "Interviews Management",
              icon: <TiPointOfInterestOutline />,
              path: "/admin/interview",
            },
            {
              label: "Selected Candidate List",
              icon: <BiPurchaseTagAlt />,
              path: "/admin/selected-candidate",
            },
            {
              label: "Purchase Order List",
              icon: <AiOutlineShoppingCart />,
              path: "/admin/purchase_order",
            },
            {
              label: "Subscription",
              icon: <PiSubtitlesThin />,
              path: "/admin/subscription",
            },
          ].map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleClick(item.path)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "8px 12px",
                cursor: "pointer",
                borderRadius: "8px",
                margin: "4px 8px",
                fontWeight: 500,
                fontSize: "14px",
                backgroundColor: isActive(item) ? "#e6f0ff" : "transparent",
                color: isActive(item) ? "#0d47a1" : "#286A94",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = isActive(item)
                  ? "#e6f0ff"
                  : "#f5f5f5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = isActive(item)
                  ? "#e6f0ff"
                  : "transparent";
              }}
            >
              <div
                style={{ fontSize: "18px", width: "24px", textAlign: "center" }}
              >
                {item.icon}
              </div>
              <span style={{ flex: 1 }}>{item.label}</span>
            </div>
          ))}
        </div>

        <div style={{ width: "100%", padding: "10px 16px", marginTop: "auto" }}>
          <button
            onClick={logoutHandler}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "10px 0",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "#f44336",
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#d32f2f")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f44336")
            }
          >
            <FaSignOutAlt style={{ fontSize: "16px" }} /> Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
